import { useQuery } from "@tanstack/react-query"
import { getCountryCurrencies, type CountryCurrency } from "@/lib/api/tax.api"
import { useAuthStore } from "@/store/auth.store"

export function useCountryCurrencies() {
  const token = useAuthStore((s) => s.accessToken)

  return useQuery<CountryCurrency[]>({
    queryKey: ["country-currencies"],
    queryFn: () => getCountryCurrencies(token ?? undefined),
    staleTime: 1000 * 60 * 60, // 1 hour cache
  })
}
